import React from 'react'

export default function Backend() {
  return (
     <div className="skills__content1">
        <h3 className="skills__title">Backend Developer</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className='bx bx-badge-check'style={{color:"Green",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">Firebase</h3>
                <span className="skills__level">Basic</span>
            </div>
        </div>
        
    </div>
  )
}
